<template>
    <section class="flex flex-col gap-3" aria-labelledby="proactive-offer-demo-heading">
        <h2 id="proactive-offer-demo-heading" class="body-small-bold text-ink">Proactive coaching offer</h2>
        <p class="body-small text-ink-muted">Generate an offer from this conversation without completing the review.</p>
        <BaseButton theme="primary" :disabled="disabled || isGenerating" :aria-busy="isGenerating" @click="generateOffer">
            {{ isGenerating ? "Generating offer…" : "Generate coaching offer" }}
        </BaseButton>
        <div aria-live="polite">
            <p v-if="errorMessage" class="body-small text-status-error">{{ errorMessage }}</p>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useFetch } from "~vue/api";
import BaseButton from "~vue/components/BaseButton.vue";
import { ref } from "vue";

const { url, disabled = false } = defineProps<{ url: string; disabled?: boolean }>();
const emit = defineEmits<{ generated: [] }>();
const isGenerating = ref(false);
const errorMessage = ref("");

async function generateOffer(): Promise<void> {
    if (disabled || isGenerating.value) {
        return;
    }
    isGenerating.value = true;
    errorMessage.value = "";
    try {
        const { error, statusCode } = await useFetch(url).post();
        if (error.value || statusCode.value !== 204) {
            errorMessage.value = error.value?.message || "Couldn't generate the offer. Please try again.";
            return;
        }
        emit("generated");
    } catch {
        errorMessage.value = "Couldn't generate the offer. Please try again.";
    } finally {
        isGenerating.value = false;
    }
}
</script>
